import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio as RadioButton,
  RadioGroup,
} from '@mui/material'
import Label from 'components/Label'
import React from 'react'
import { Control, Controller } from 'react-hook-form'

type ControlRadioProps = {
  name: string
  label: string
  control: Control<any>
  options: RadioOption[]
  disabled?: boolean
}

export type RadioOption = {
  value: boolean
  label: string
}

const ControlRadioBoolean: React.FC<ControlRadioProps> = ({
  name,
  label,
  control,
  options,
  disabled,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <FormControl>
          <FormLabel id={`${name}LabelId`}>
            <Label text={label} sx={{ fontSize: 14, color: 'text.primary' }} />
          </FormLabel>
          <RadioGroup row value={value} onChange={(e) => onChange(e.target.value === 'true')}>
            {options.map((option, index) => (
              <FormControlLabel
                disabled={disabled}
                key={index}
                checked={value === option.value}
                value={option.value.toString()}
                control={<RadioButton size='small' color='secondary' />}
                label={option.label}
              />
            ))}
          </RadioGroup>
          {error && error.message && (
            <Label text={error.message} sx={{ fontSize: 12, color: 'error.main' }} />
          )}
        </FormControl>
      )}
    />
  )
}

export default ControlRadioBoolean
